import { render, staticRenderFns } from "./AsyncItemListLoader.vue?vue&type=template&id=12a1c0b8"
import script from "./AsyncItemListLoader.vue?vue&type=script&lang=js"
export * from "./AsyncItemListLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports